module.exports = __webpack_public_path__ + "media/images/athletes/1621-3e545bb5236fdf9e724d2bccab41f4a6.png";